import { Copy } from 'lucide-react';
import { type TestResult } from './agentTypes';

interface AgentTestResultPanelProps {
  result: TestResult;
  onCopyCfRay: (ray: string) => void;
}

/** Renders the green-OK or red-error panel below a role's Test button. */
export function AgentTestResultPanel({ result, onCopyCfRay }: AgentTestResultPanelProps) {
  return (
    <div
      className={`rounded border px-3 py-2 text-xs ${
        result.ok
          ? 'border-green-200 bg-green-50 text-green-900 dark:border-green-900 dark:bg-green-950 dark:text-green-100'
          : 'border-destructive/40 bg-destructive/10 text-destructive'
      }`}
    >
      {result.ok ? (
        <>
          <div className="flex items-center justify-between mb-1 font-medium">
            <span>OK · {result.duration_ms}ms · {result.tokens_used} tokens</span>
          </div>
          <pre className="whitespace-pre-wrap font-mono text-[11px] leading-snug">
            {result.output}
          </pre>
        </>
      ) : (
        <div className="space-y-1.5">
          <div className="font-medium">{result.error}</div>
          {result.hint && <div className="text-[11px] opacity-80">{result.hint}</div>}
          {result.cf_ray && (
            <button
              type="button"
              onClick={() => { onCopyCfRay(result.cf_ray ?? ''); }}
              className="inline-flex items-center gap-1 font-mono text-[11px] opacity-70 hover:opacity-100"
              title="Copy Cloudflare Ray-ID for Kaycoo support"
            >
              cf-ray={result.cf_ray}
              <Copy className="h-3 w-3" aria-hidden="true" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
